/* eslint-disable prefer-destructuring */
import { withContextualizedTracking, track, useTracking } from 'lib/analytics'
import { InfoButton } from 'components/buttons'
import { createBirthdayWishlistPath, createHolidayWishlistPath } from 'lib/urls'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'

export interface PostConfettiBannerProps {
  content: string
  title: string
}

function extractButtonAndParagraph(htmlString: string) {
  const pattern = /<p>(.*?)<button[^>]*>.*?<\/button><\/p>/i
  const buttonDataPattern = /<button[^>]*name="([^"]*)"[^>]*>(.*?)<\/button>/i

  const match = htmlString.match(pattern)

  let buttonString = ''
  let htmlContent = htmlString
  let buttonText = ''
  let buttonName = ''

  if (match) {
    buttonString = match[0]
    htmlContent = htmlString.replace(pattern, '')
  }

  if (buttonString) {
    const buttonDataMatch = buttonString.match(buttonDataPattern)
    if (buttonDataMatch) {
      buttonText = buttonDataMatch[2]
      buttonName = buttonDataMatch[1]
    }
  }

  return { htmlContent, buttonString, buttonText, buttonName }
}

function PostConfettiBanner({ content, title }: PostConfettiBannerProps) {
  const tracker = useTracking()
  const [currentUser] = useCurrentUser()

  if (!currentUser) {
    return null
  }

  const { htmlContent, buttonString, buttonText, buttonName } =
    extractButtonAndParagraph(content)

  const handleCreateNewRegistryClicked = (listType: string, href: string) => {
    tracker.trackEvent({
      event: track.listTypeClicked,
      eventLocation: track.EventLocation.GUIDES,
      listType,
      registryId: currentUser?.registryId,
      registryOwnerId: currentUser?.id,
    })
    window.location.href = href
  }

  const WishlistCTA = () => {
    let listType: string
    let href: string

    switch (buttonName) {
      case 'birthday-cta':
        listType = track.ListType.BIRTHDAY
        href = createBirthdayWishlistPath
        break
      case 'holiday-cta':
        listType = track.ListType.HOLIDAY
        href = createHolidayWishlistPath
        break
      default:
    }

    return (
      <InfoButton
        pill
        onClick={() => handleCreateNewRegistryClicked(listType, href)}
      >
        {buttonText}
      </InfoButton>
    )
  }

  const displayWishlistCTA =
    buttonName === 'birthday-cta' || buttonName === 'holiday-cta'

  return (
    <div className="edge-to-edge confetti-wrapper">
      <div className="confetti">
        <h3 className="mtn mbl text-center">{title}</h3>
        <div className="text-center mbl">
          <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
          {displayWishlistCTA ? (
            <WishlistCTA />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: buttonString }} />
          )}
        </div>
      </div>
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.GUIDE,
})(PostConfettiBanner)
